import { render, staticRenderFns } from "./PageRegisterSuccess.vue?vue&type=template&id=5a1f0a88&"
import script from "./PageRegisterSuccess.vue?vue&type=script&lang=js&"
export * from "./PageRegisterSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PageRegisterSuccess.vue?vue&type=style&index=0&id=5a1f0a88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports